import { Component } from '@angular/core';
import { UntypedFormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-page-password',
    templateUrl: './page-password.component.html',
    styleUrls: ['./page-password.component.sass'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, TranslateModule]
})
export class PagePasswordComponent {
    constructor(private fb: UntypedFormBuilder,
        private authService: AuthenticationService,
        private toastr: ToastrService,
        private router: Router) { }

    userDetails;

    form = this.fb.group({
        password: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]],
        oldPassword: ['', [Validators.required]]
    })
    ngOnInit() {
    }

    submit() {
        if (this.form.invalid) {
            this.toastr.error('Fill the required fields');
            return;
        }
        if (this.password == this.oldPassword) {
            this.toastr.error("Current password must not be the same");
            return;
        }
        if (this.confirmPassword != this.password) {
            this.toastr.error('Password must match');
            return;
        }

        this.authService.changePassword(this.password, this.oldPassword).subscribe(response => {
            if (response.code == 200) {
                this.toastr.success(response.msg);
                this.authService.logout().subscribe(res=>{
                    res
                });
                this.router.navigate(['/']);
            }

            if (response.code == 400) {
                this.toastr.error(response.msg);
            }
        })
    }

    get password() {
        return this.form.get('password').value;
    }
    get confirmPassword() {
        return this.form.get('confirmPassword').value;
    }
    get oldPassword() {
        return this.form.get('oldPassword').value;
    }
}
